import { forwardRef } from "react";
import { cn } from "@/utils/cn";

export interface InputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "className"> {
  className?: string;
}

/* Use :focus (not only :focus-visible): iOS Safari often skips focus-visible rings/caret cues on touch until typing. */
const inputBase =
  "flex h-11 w-full rounded-md border border-slate-200 bg-slate-50 px-3 py-2 text-base md:text-sm text-slate-900 placeholder:text-slate-500 caret-slate-900 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:border-slate-300 disabled:cursor-not-allowed disabled:opacity-50";

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(inputBase, className)}
      {...props}
    />
  )
);
Input.displayName = "Input";
